import { Agent, CreateAgentRequest, UpdateAgentRequest } from "../../models/agent"
import { apiInstance } from "../instances/apiInstance"
import { ParameterDeclarationDto } from "../../models/parameterDeclaration"

const agentsController = {
    getAgents: (projectId: string): Promise<Agent[]> =>
        apiInstance.get(`/projects/${projectId}/agents`).then(response => response.data),
    getDeclarations: (type: string): Promise<ParameterDeclarationDto[]> =>
        apiInstance.get(`/agents/${type}/declarations`).then(response => response.data),
    create: (projectId: string, agentId: string, request: CreateAgentRequest): Promise<Agent> =>
        apiInstance.post(`/projects/${projectId}/agents/${agentId}`, request).then(response => response.data),
    update: (projectId: string, agentId: string, request: UpdateAgentRequest): Promise<Agent> =>
        apiInstance.put(`/projects/${projectId}/agents/${agentId}`, request).then(response => response.data),
    delete: (projectId: string, agentId: string): Promise<void> =>
        apiInstance.delete(`/projects/${projectId}/agents/${agentId}`).then(response => response.data)
}

export default agentsController
